import { BackLink, WellMode } from '../../../../../types/routing-types'
import WellPage from '../../../../components/wells/well-page'
import WellPageErrorBoundary from '../../../../components/errors/components/error-boundary'
import { usePageState } from '../../../../context/page-context'
import { useWellHeader } from '../../../../hooks/use-api'
import { useEffect } from 'react'
import { useWellId } from '../../../../hooks/use-well-id'

export default function ViewWell({ backLink }: { backLink: BackLink }) {
  if (!backLink) throw new Error(`No backlink defined for Well view pages`)
  const { setPageState } = usePageState()
  const id = useWellId()
  const { isSuccess, data } = useWellHeader(id ? id : WellMode.NEW)

  useEffect(() => {
    if (isSuccess && data?.state) {
      const { displayName } = data.state
      setPageState((prevPageState) => ({
        ...prevPageState,
        backLink: backLink,
        heading: displayName,
      }))
    }
  }, [isSuccess, data?.state, id, setPageState, backLink])

  return (
    <WellPageErrorBoundary>
      <WellPage mode={WellMode.VIEW} />
    </WellPageErrorBoundary>
  )
}
